/* eslint-disable */
// @ts-nocheck

import { AlertTriangleIcon, UploadIcon } from 'lucide-react'

import OrderStatusBadge from '@/components/misc/badges/OrderStatusBadge'
import { TableColumn } from '@/components/new/table/DataTable'
import { IExpedient } from '@/containers/logistic/expedients/interfaces/interfaces'
import { IDocumentTable } from '@/containers/logistic/expedients/wizzardExpedient/tabs/document/interfaces'
import { formatDateForTable } from '@/utils/helpers'

import { IProduct } from '../../../interfaces/interfaces'

export const columns: TableColumn<any>[] = [
  {
    accessorKey: 'name',
    header: 'Nombre',
    cell: ({ row }) => {
      return (
        <p className={'py-1 font-medium'}>
          {row.original?.product?.name ||
            row.original?.name ||
            `Product ${row.original?.productId}` ||
            '-'}
        </p>
      )
    },
  },
  {
    accessorKey: 'uniqueCode',
    header: 'Lote',
    cell: ({ row }) => {
      return (
        <p className={'py-1 font-medium'}>
          {row.original?.uniqueCode || '-'}
        </p>
      )
    },
  },
  {
    accessorKey: 'entryQuantity',
    header: 'Cantidad Inicial',
    cell: ({ row }) => {
      // Use entryQuantity directly from batch data
      const entryQuantity = row.original?.entryQuantity
      return <p className={'py-1 font-medium'}>{entryQuantity || '0'}</p>
    },
  },
  {
    accessorKey: 'availableQuantity',
    header: 'Cantidad Disponible',
    cell: ({ row }) => {
      // Use availableQuantity directly from batch data
      const availableQuantity = row.original?.availableQuantity
      return <p className={'py-1 font-medium'}>{availableQuantity || '0'}</p>
    },
  },
  {
    accessorKey: 'grossCost',
    header: 'Costo Bruto',
    cell: ({ row }) => {
      // Use grossCost.amount directly from batch data
      const grossCost = row.original?.grossCost?.amount
      return (
        <p className={'py-1 font-medium'}>
          {grossCost && parseFloat(grossCost) >= 0
            ? parseFloat(grossCost).toFixed(4)
            : '0.0000'}
        </p>
      )
    },
  },
  {
    accessorKey: 'netCost',
    header: 'Costo Neto',
    cell: ({ row }) => {
      // Use netCost.amount directly from batch data
      const netCost = row.original?.netCost?.amount
      return (
        <p className={'py-1 font-medium'}>
          {netCost && parseFloat(netCost) >= 0
            ? parseFloat(netCost).toFixed(4)
            : '0.0000'}
        </p>
      )
    },
  },
]
